import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import TheoryExamplesRunner from "../../components/TheoryExamplesRunner";

export default function ArithmeticSequencePreparationTheory() {
  const intro = (
    <div className="space-y-3">
      <p>
        W ciągu arytmetycznym różnica między każdym wyrazem a poprzednim jest
        stała. Oznaczamy ją literą <InlineMath math="r" />.
      </p>
      <BlockMath math={String.raw`a_{n+1}=a_n+r\qquad r=a_{n+1}-a_n`} />
      <p>Znając pierwszy wyraz i różnicę, obliczamy dowolny wyraz ze wzoru:</p>
      <BlockMath math="a_n=a_1+(n-1)r" />
      <p>Suma pierwszych <InlineMath math="n" /> wyrazów jest równa:</p>
      <BlockMath math={String.raw`S_n=\frac{n}{2}(a_1+a_n)=\frac{n}{2}\bigl(2a_1+(n-1)r\bigr)`} />
      <p>Dla trzech kolejnych wyrazów wyraz środkowy jest średnią arytmetyczną sąsiednich:</p>
      <BlockMath math={String.raw`a_n=\frac{a_{n-1}+a_{n+1}}{2}`} />
    </div>
  );

  const examples = [
    {
      label: "Przykład 1",
      summary: "Obliczanie szóstego wyrazu ciągu arytmetycznego",
      description: "Z danych a₁ = 4 i r = 3 obliczamy konkretnie wyraz a₆.",
      content: <BlockMath math={String.raw`a_1=4,\ r=3\quad\Longrightarrow\quad a_6=4+5\cdot3=19`} />,
    },
    {
      label: "Przykład 2",
      summary: "Obliczanie różnicy na podstawie wyrazów a₂ i a₆",
      description: "Między a₂ i a₆ wykonujemy cztery przejścia o tę samą różnicę r.",
      content: <BlockMath math={String.raw`a_2=5,\ a_6=17\quad\Longrightarrow\quad r=\frac{17-5}{6-2}=3`} />,
    },
    {
      label: "Przykład 3",
      summary: "Obliczanie sumy pięciu początkowych wyrazów",
      description: "Z danych a₁ = 2 i r = 3 obliczamy konkretnie sumę S₅.",
      content: <BlockMath math={String.raw`a_1=2,\ r=3\quad\Longrightarrow\quad S_5=\frac{5}{2}\bigl(2\cdot2+4\cdot3\bigr)=40`} />,
    },
  ];

  return <TheoryExamplesRunner intro={intro} examples={examples} />;
}
